export enum flooriAssetsNames {
    desktopPreview = 'desktop-preview',
    mobilePreview = 'mobile-preview',
    defaultHeader = 'default-header',
    clarityScript = 'clarity-script',
}

export const flooriAssets: Record<flooriAssetsNames, string> = {
    [flooriAssetsNames.desktopPreview]: '/assets/images/full_preview.png',
    [flooriAssetsNames.mobilePreview]: '/assets/images/mobile_preview.png',
    [flooriAssetsNames.defaultHeader]: '/custom_headers/defaultHeader.html',
    [flooriAssetsNames.clarityScript]: '/assets/scripts/clarity.js',
} as const;
